import profileRepo from '@/repository/generatedRepository/profileRepository'
// import i18n from '@/plugins/vue-i18n';
// import i18nService from "@/services/i18n.service";
const state = {
  profile: null,
  profilePermissions: [],
}

const getters = {
  profile: state => state.profile,
  profilePermissions: state => new Set(state.profilePermissions),
  isManager: state => state.profile.role === 'MANAGER',
  isPartner: state => state.profile.role === 'PARTNER',
  offerCategoryAvailable: state => !!state.profile?.offerCategoryAvailable,
  profileHasFullAccess: (state, getters) => {
    return getters.profilePermissions.has('FULL_ACCESS')
  },
}

const actions = {
  async loadProfile(context) {
    const { data } = await profileRepo.get()
    if (data.enabled === false) {
      return context.dispatch('AuthModule/onLogout', null, { root: true })
    }
    context.commit('setProfile', data)
    context.commit('setProfilePermissions', data.permissions || [])
    // i18n.locale = data.payload.locale || 'ru'
    // i18nService.setActiveLanguage(data.payload.locale || 'ru')
    return { profile: data }
  },
  onRecoverEmail(context, payload) {
    return profileRepo.recover(payload)
  },
  onResetPassword(context, payload) {
    const { token, ...form } = payload
    return profileRepo.resetPassword(form, { token })
  },
  onCheckToken(context, token) {
    return profileRepo.checkToken({ token })
  },
  async loadOwnSessions() {
    const { data } = await profileRepo.getSessions()
    return data
  },
  async deleteOwnSession(context, sessionId) {
    return profileRepo.deleteSession(sessionId)
  },
  async closeAllOwnSessions({ dispatch }, sessions) {
    const promises = sessions.map(session => dispatch('deleteOwnSession', session.id))
    return Promise.all(promises)
  },
  async changePassword(context, payload) {
    return profileRepo.changePassword(payload)
  },
  ws_change_permission({ dispatch, getters }, id) {
    if (id === getters.profile?.id) dispatch('loadProfile')
  },
}

const mutations = {
  setProfile(state, payload = null) {
    state.profile = payload
  },
  setProfilePermissions(state, payload) {
    state.profilePermissions = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
